import { ArrowBack } from "@mui/icons-material"
import { ListButton, Show, SimpleShowLayout, TextField, Labeled } from "react-admin"
import { TopToolBar } from "../shared-components"
import _ from "lodash"

export const ShowNoteTitle: React.FC = (data: any) => {
  return (
    <a style={{ color: "#ffffff", textDecoration: "none" }} href={`#/profiles/${data.record.user_id}/show/notes`}>
      <span style={{ fontWeight: 600 }}>{data.record.userName}</span> {data.record.user_id}{" "}
    </a>
  )
}

const BackToProfile = ({ url }: { url: string }): JSX.Element => {
  return <ListButton to={{ pathname: url }} label={"Go back"} icon={<ArrowBack />} />
}

const shouldShowColumn = (columnName: string, parsedRecordText: any, isArray: boolean) => {
  if (isArray) {
    return _.get(parsedRecordText, `0.${columnName}`)
  } else {
    return _.get(parsedRecordText, columnName)
  }
}

const ShowNoteDetails: React.FC = (data: any) => {
  try {
    const parsedRecordText = JSON.parse(data.record.text)
    const isNotesArray = Array.isArray(parsedRecordText)
    const displayReason = shouldShowColumn("reason", parsedRecordText, isNotesArray) ? "block" : "none"
    const displayDeactivationReason = shouldShowColumn("deactivation_reason", parsedRecordText, isNotesArray) ? "block" : "none"
    let body
    // show rows of field changes, or if just single field change, one row of field change
    if (Array.isArray(parsedRecordText)) {
      body = _.map(parsedRecordText, (row, index) => {
        return (
          <tr key={index}>
            <td>
              <TextField record={row} source="field" />
            </td>
            <td>
              <TextField record={row} source="changed_from" />
            </td>
            <td>
              <TextField record={row} source="changed_to" />
            </td>
            <td style={{ display: displayDeactivationReason }}>
              <TextField record={row} source="deactivation_reason" />
            </td>
            <td style={{ display: displayReason }}>
              <TextField record={row} source="reason" />
            </td>
          </tr>
        )
      })
    } else {
      body = (
        <tr>
          <td>
            <TextField record={parsedRecordText} source="field" />
          </td>
          <td>
            <TextField record={parsedRecordText} source="changed_from" />
          </td>
          <td>
            <TextField record={parsedRecordText} source="changed_to" />
          </td>
          <td style={{ display: displayDeactivationReason }}>
            <TextField record={parsedRecordText} source="deactivation_reason" />
          </td>
          <td style={{ display: displayReason }}>
            <TextField record={parsedRecordText} source="reason" />
          </td>
        </tr>
      )
    }

    return (
      <table>
        <thead>
          <tr>
            <th>Field</th>
            <th>Changed From</th>
            <th>Changed To</th>
            <th style={{ display: displayDeactivationReason }}>Deactivation Reason</th>
            <th style={{ display: displayReason }}>Reason</th>
          </tr>
        </thead>
        <tbody>{body}</tbody>
      </table>
    )
  } catch (err) {
    return (
      <Labeled label="Note text">
        <TextField source="text" label="Note text" />
      </Labeled>
    )
  }
}

export const NoteShow: React.FC = (props: any) => {
  const ShowActions = () => {
    return <TopToolBar left={<BackToProfile url={props.location?.state?.goBackUrl} />} />
  }
  return (
    <Show title={<ShowNoteTitle />} actions={<ShowActions />} {...props}>
      <SimpleShowLayout>
        <ShowNoteDetails />
      </SimpleShowLayout>
    </Show>
  )
}
